// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".primary-text{min-height:140px!important}.seasidetms_icon_list_item{padding-bottom:15px!important}.secondary-text{min-height:190px!important}.delivery-block{clear:both;margin-top:30px}", ""]);
// Exports
module.exports = exports;
